export const articles = [
  {
    slug: 'zixun-zhaohui-2026',
    title: '地址找回指南：2026年最新官方入口汇总',
    category: 'zixun',
    categoryName: '最新资讯',
    excerpt: '本文汇总了2026年最新的官方访问地址，包括主域名入口和各地区备用地址，确保您随时可以找到正确的访问链接。收藏本文，再也不怕找不到回家的路。',
    content: `在互联网环境中，访问地址的变更时有发生。为了让广大用户能够持续稳定地访问我们的服务，我们特别整理了2026年最新的官方访问地址汇总。

<h2>主域名入口</h2>
<p>主域名始终是我们推荐的首选访问方式。请认准以下官方主域名：</p>
<ul>
  <li>官方主站：https://www.official-site.com</li>
  <li>备用主站：https://www.official-site.cn</li>
</ul>

<h2>各区域备用地址</h2>
<p>针对不同地区的网络环境，我们提供了多个备用访问地址：</p>
<ul>
  <li>华东地区：https://hd.official-site.com</li>
  <li>华南地区：https://hn.official-site.com</li>
  <li>华北地区：https://hb.official-site.com</li>
  <li>西南地区：https://xn.official-site.com</li>
</ul>

<h2>如何验证官方地址</h2>
<p>为了防止访问到仿冒网站，请务必通过以下方式验证：</p>
<ol>
  <li>检查网址是否以官方域名结尾</li>
  <li>查看页面底部是否有官方备案信息</li>
  <li>确认SSL证书信息是否正确</li>
  <li>通过本地址发布页的链接跳转</li>
</ol>

<h2>收藏建议</h2>
<p>我们强烈建议您将本地址发布页添加到浏览器收藏夹。这样无论主地址如何变化，您都可以通过本页找到最新的官方入口。</p>
<p>同时，您也可以关注我们的官方社交媒体账号，获取第一手的地址更新通知。</p>`,
    date: '2026-08-05',
    readTime: '5分钟',
    views: 12850,
    imageSeq: 'article-addr-guide',
  },
  {
    slug: 'zixun-yunwei-2026',
    title: '2026年第三季度运维报告：服务稳定性提升至99.9%',
    category: 'zixun',
    categoryName: '最新资讯',
    excerpt: '最新运维数据显示，我们的服务可用性已达到99.9%。本文详细介绍了我们在基础设施优化、安全防护升级和用户体验改善方面的工作成果。',
    content: `2026年第三季度即将到来，我们很高兴地向大家汇报最新的运维成果。

<h2>服务可用性数据</h2>
<p>经过持续的基础设施优化，我们的服务可用性已提升至99.9%，这意味着全年预计停机时间不超过8.76小时。以下是关键指标：</p>
<ul>
  <li>月度平均在线率：99.93%</li>
  <li>平均响应时间：&lt;200ms</li>
  <li>CDN节点覆盖：全球50+节点</li>
  <li>DDoS防护能力：T级别</li>
</ul>

<h2>安全防护升级</h2>
<p>我们引入了多层安全防护体系，包括但不限于：</p>
<ul>
  <li>Web应用防火墙（WAF）实时防护</li>
  <li>智能爬虫识别与拦截系统</li>
  <li>7x24小时安全运营中心监控</li>
  <li>定期第三方安全审计</li>
</ul>

<h2>用户体验改善</h2>
<p>我们始终将用户体验放在首位。本季度我们完成了以下优化：</p>
<ul>
  <li>页面加载速度提升40%</li>
  <li>移动端适配全面优化</li>
  <li>新增暗色模式支持</li>
  <li>无障碍访问功能完善</li>
</ul>

<p>感谢所有用户一直以来的支持与信任！我们将继续努力，为大家提供更稳定、更安全的服务。</p>`,
    date: '2026-08-03',
    readTime: '4分钟',
    views: 8920,
    imageSeq: 'article-ops-report',
  },
  {
    slug: 'zixun-beiyong-2026',
    title: '备用地址系统全面升级：更智能、更快速、更稳定',
    category: 'zixun',
    categoryName: '最新资讯',
    excerpt: '备用地址导航系统迎来重大升级，新增智能路由功能，可根据用户网络环境自动推荐最佳访问节点，让访问体验更加流畅稳定。',
    content: `我们很高兴地宣布，备用地址导航系统已完成全面升级。新系统引入了多项创新技术，为用户提供更优质的访问体验。

<h2>智能路由功能</h2>
<p>新系统可以根据用户的网络环境自动选择最佳的访问节点：</p>
<ul>
  <li>实时网络延迟检测</li>
  <li>智能节点选择算法</li>
  <li>故障自动切换机制</li>
  <li>访问速度持续优化</li>
</ul>

<h2>新增功能亮点</h2>
<p>本次升级带来了多项实用功能：</p>
<ul>
  <li>一键测速：快速检测所有节点响应速度</li>
  <li>收藏同步：登录后跨设备同步收藏地址</li>
  <li>访问历史：自动记录最近的访问地址</li>
  <li>状态监控：实时显示各节点运行状态</li>
</ul>

<h2>技术架构升级</h2>
<p>后端架构从单体升级为微服务架构，实现了：</p>
<ul>
  <li>更高的系统可扩展性</li>
  <li>更快的故障恢复能力</li>
  <li>更灵活的功能迭代速度</li>
  <li>更低的运维成本</li>
</ul>

<p>立即体验全新的备用地址系统，享受前所未有的流畅访问！</p>`,
    date: '2026-07-28',
    readTime: '5分钟',
    views: 7650,
    imageSeq: 'article-backup-system',
  },
  {
    slug: 'jiaocheng-ruhe-shoucang',
    title: '详细教程：如何正确收藏地址发布页并设置更新提醒',
    category: 'jiaocheng',
    categoryName: '使用教程',
    excerpt: '本文将手把手教您如何在不同浏览器和设备上收藏地址发布页，以及如何设置更新提醒，确保您永远不会错过任何重要通知。',
    content: `收藏地址发布页是确保随时找到官方入口的最佳方式。本教程将详细说明在不同平台上的收藏方法。

<h2>电脑端浏览器收藏</h2>
<p><strong>Chrome 浏览器：</strong></p>
<ol>
  <li>打开本地址发布页</li>
  <li>点击地址栏右侧的星形图标</li>
  <li>选择保存位置（建议保存到书签栏）</li>
  <li>点击"完成"即可</li>
</ol>

<p><strong>Edge 浏览器：</strong></p>
<ol>
  <li>打开本地址发布页</li>
  <li>按 Ctrl+D（Mac: Cmd+D）</li>
  <li>选择保存文件夹</li>
  <li>点击"保存"即可</li>
</ol>

<h2>手机端收藏方法</h2>
<p><strong>iOS Safari：</strong></p>
<ol>
  <li>打开本地址发布页</li>
  <li>点击底部中间"分享"按钮</li>
  <li>选择"添加到主屏幕"</li>
  <li>点击"添加"即可在桌面创建快捷图标</li>
</ol>

<p><strong>Android Chrome：</strong></p>
<ol>
  <li>打开本地址发布页</li>
  <li>点击右上角三个点菜单</li>
  <li>选择"添加到主屏幕"</li>
  <li>点击"添加"即可</li>
</ol>

<h2>设置更新提醒</h2>
<p>关注我们的官方渠道获取更新通知：</p>
<ul>
  <li>官方微博：@地址发布页官方</li>
  <li>官方公众号：地址发布页</li>
  <li>邮件订阅：在页面底部输入邮箱订阅</li>
</ul>

<p>完成以上步骤，您就再也不会错过任何重要的地址更新信息了！</p>`,
    date: '2026-07-25',
    readTime: '4分钟',
    views: 15600,
    imageSeq: 'article-bookmark-guide',
  },
  {
    slug: 'jiaocheng-ruhe-gengxin',
    title: '如何第一时间获取地址更新：通知订阅与自动检测指南',
    category: 'jiaocheng',
    categoryName: '使用教程',
    excerpt: '学会使用多种方式获取地址更新通知，包括浏览器通知、邮件订阅和RSS订阅。同时了解如何使用自动检测工具实时监控地址可用性。',
    content: `及时获取地址更新通知对于保持稳定访问至关重要。本文将介绍多种获取更新通知的方法。

<h2>浏览器通知订阅</h2>
<p>当您首次访问本站时，浏览器会询问是否允许通知。点击"允许"后，您将在地址有更新时第一时间收到浏览器推送通知。</p>
<p>如果您之前拒绝了通知权限，可以按以下步骤重新开启：</p>
<ol>
  <li>点击浏览器地址栏左侧的锁形图标</li>
  <li>找到"通知"选项</li>
  <li>将权限改为"允许"</li>
  <li>刷新页面即可生效</li>
</ol>

<h2>邮件订阅</h2>
<p>在页面底部找到邮件订阅区域，输入您的邮箱地址即可完成订阅。我们会在以下情况发送邮件：</p>
<ul>
  <li>主域名地址变更时</li>
  <li>新增备用地址时</li>
  <li>重要系统维护公告</li>
  <li>安全事件通知</li>
</ul>

<h2>RSS订阅</h2>
<p>对于技术用户，我们提供了RSS订阅地址：</p>
<p>https://www.official-site.com/rss/updates.xml</p>
<p>使用任意RSS阅读器添加此地址即可接收更新推送。</p>

<h2>自动检测工具</h2>
<p>我们还提供了地址可用性自动检测脚本，可以部署在您的服务器上：</p>
<ul>
  <li>定时检测所有备用地址的可用性</li>
  <li>自动切换到可用节点</li>
  <li>发送异常告警通知</li>
  <li>生成可用性报告</li>
</ul>`,
    date: '2026-07-20',
    readTime: '6分钟',
    views: 11200,
    imageSeq: 'article-update-notify',
  },
  {
    slug: 'jiaocheng-xinshou-zhinan',
    title: '新手完全指南：从零开始使用地址发布页',
    category: 'jiaocheng',
    categoryName: '使用教程',
    excerpt: '全新用户必读！本文涵盖地址发布页的所有核心功能使用说明，从基础访问到高级设置，帮助您在5分钟内成为熟练用户。',
    content: `欢迎来到地址发布页！本指南将帮助您在最短时间内掌握所有核心功能。

<h2>第一步：了解地址发布页</h2>
<p>地址发布页是官方唯一指定的地址入口导航平台。在这里，您可以：</p>
<ul>
  <li>查看所有官方访问地址</li>
  <li>获取最新的地址更新通知</li>
  <li>阅读官方公告和使用教程</li>
  <li>联系客服获取帮助</li>
</ul>

<h2>第二步：收藏本页</h2>
<p>强烈建议立即收藏本页。在主域名或备用地址发生变更时，本页将始终保持可访问状态，是您找回正确地址的最可靠途径。</p>

<h2>第三步：选择访问入口</h2>
<p>在首页的地址入口区域，您可以看到所有可用的访问地址。建议优先使用主域名，如遇访问问题可尝试备用地址。</p>

<h2>第四步：关注更新</h2>
<p>通过邮件订阅或浏览器通知，确保第一时间获取地址更新信息。</p>

<h2>第五步：遇到问题？</h2>
<p>访问我们的"常见问题"栏目，或通过"关于我们"页面的联系方式与我们取得联系。</p>`,
    date: '2026-07-15',
    readTime: '3分钟',
    views: 21200,
    imageSeq: 'article-beginner-guide',
  },
  {
    slug: 'wenti-wufa-fangwen',
    title: '常见问题解答：无法访问时的排查步骤与解决方案',
    category: 'wenti',
    categoryName: '常见问题',
    excerpt: '当您遇到无法访问的情况时，请按照本文的排查步骤逐一检查。我们整理了最常见的访问问题及对应的解决方案，帮助您快速恢复访问。',
    content: `访问问题可能由多种原因导致。请按照以下步骤逐一排查。

<h2>排查步骤</h2>

<h3>1. 检查网络连接</h3>
<p>确保您的设备已连接到互联网。尝试访问其他网站确认网络是否正常。</p>

<h3>2. 尝试备用地址</h3>
<p>如果主域名无法访问，请尝试使用备用地址。我们提供了多个区域节点，可以逐一尝试。</p>

<h3>3. 清除DNS缓存</h3>
<p>Windows系统：</p>
<ul>
  <li>打开命令提示符（以管理员身份运行）</li>
  <li>输入 ipconfig /flushdns 并回车</li>
  <li>重启浏览器后重试</li>
</ul>
<p>Mac系统：</p>
<ul>
  <li>打开终端</li>
  <li>输入 sudo dscacheutil -flushcache 并回车</li>
  <li>重启浏览器后重试</li>
</ul>

<h3>4. 更换DNS服务器</h3>
<p>建议使用以下公共DNS：</p>
<ul>
  <li>Google DNS：8.8.8.8 / 8.8.4.4</li>
  <li>Cloudflare DNS：1.1.1.1 / 1.0.0.1</li>
  <li>阿里DNS：223.5.5.5 / 223.6.6.6</li>
</ul>

<h3>5. 检查浏览器设置</h3>
<p>确保浏览器未启用代理，且JavaScript和Cookie功能已开启。</p>

<h2>仍然无法访问？</h2>
<p>如果以上步骤都无法解决问题，请通过"关于我们"页面的联系方式与我们联系，我们将第一时间协助您解决。</p>`,
    date: '2026-07-10',
    readTime: '5分钟',
    views: 18900,
    imageSeq: 'article-access-issue',
  },
  {
    slug: 'wenti-jiaman-jiejue',
    title: '访问加载缓慢？教你几招提速技巧',
    category: 'wenti',
    categoryName: '常见问题',
    excerpt: '如果访问速度不理想，本文提供的几个实用技巧可以帮助您显著提升加载速度。从浏览器优化到网络设置，总有一招适合您。',
    content: `访问速度慢会影响使用体验。以下是一些实用的提速技巧。

<h2>浏览器优化</h2>
<ul>
  <li>定期清理浏览器缓存和Cookie</li>
  <li>关闭不必要的浏览器扩展</li>
  <li>更新浏览器到最新版本</li>
  <li>开启浏览器的硬件加速功能</li>
</ul>

<h2>网络优化</h2>
<ul>
  <li>选择距离最近的备用节点访问</li>
  <li>使用有线网络代替WiFi</li>
  <li>更换更优质的DNS服务器</li>
  <li>关闭后台下载任务</li>
</ul>

<h2>系统优化</h2>
<ul>
  <li>关闭不必要的后台程序</li>
  <li>定期重启路由器和设备</li>
  <li>检查系统是否有恶意软件</li>
  <li>保持操作系统更新到最新版本</li>
</ul>

<h2>节点选择建议</h2>
<p>华北用户建议使用hb节点，华东用户使用hd节点，华南用户使用hn节点，西南用户使用xn节点。选择距离最近的节点可以有效降低延迟。</p>`,
    date: '2026-07-05',
    readTime: '3分钟',
    views: 14300,
    imageSeq: 'article-speed-tips',
  },
  {
    slug: 'wenti-zhanghao-anquan',
    title: '账号安全常见问题：如何保护您的账户不受侵害',
    category: 'wenti',
    categoryName: '常见问题',
    excerpt: '账号安全是每位用户都应重视的问题。本文整理了最常见的账号安全问题和防护措施，帮助您远离盗号和钓鱼风险。',
    content: `账号安全不容忽视。以下是最常见的账号安全问题和防护建议。

<h2>设置强密码</h2>
<p>一个强密码应包含：</p>
<ul>
  <li>至少12个字符</li>
  <li>大写字母、小写字母、数字和特殊符号的组合</li>
  <li>避免使用个人信息（生日、姓名等）</li>
  <li>不同平台使用不同的密码</li>
</ul>

<h2>开启二次验证</h2>
<p>强烈建议开启二次验证（2FA），即使密码泄露，攻击者也无法登录您的账户。</p>

<h2>警惕钓鱼攻击</h2>
<ul>
  <li>不要点击来历不明的链接</li>
  <li>仔细检查网址是否为官方域名</li>
  <li>不要在任何非官方页面输入账号密码</li>
  <li>通过本地址发布页访问最安全</li>
</ul>

<h2>定期安全检查</h2>
<ul>
  <li>定期查看登录记录</li>
  <li>检查关联设备列表</li>
  <li>及时撤销不认识的设备授权</li>
  <li>发现异常立即修改密码</li>
</ul>`,
    date: '2026-06-28',
    readTime: '4分钟',
    views: 16700,
    imageSeq: 'article-account-security',
  },
  {
    slug: 'gonggao-zhengshi-shangxian',
    title: '官方公告：地址发布页正式上线运营',
    category: 'gonggao',
    categoryName: '官方公告',
    excerpt: '经过数月的精心筹备，官方地址发布页于今日正式上线运营。作为官方唯一指定的地址入口导航平台，我们将为所有用户提供最可靠的地址服务。',
    content: `我们非常高兴地宣布：官方地址发布页于今日正式上线运营！

<h2>关于我们</h2>
<p>地址发布页是官方唯一指定的地址入口导航平台。我们的使命是为所有用户提供稳定、安全、便捷的地址导航服务。</p>

<h2>核心功能</h2>
<ul>
  <li><strong>最新地址展示</strong>：实时更新官方最新访问地址</li>
  <li><strong>备用地址导航</strong>：提供多个区域备用节点</li>
  <li><strong>状态监控</strong>：各节点运行状态实时可见</li>
  <li><strong>更新通知</strong>：多渠道推送地址变更通知</li>
  <li><strong>使用教程</strong>：详细的访问和使用指南</li>
</ul>

<h2>我们的承诺</h2>
<ul>
  <li>服务可用性不低于99.9%</li>
  <li>地址变更提前24小时通知</li>
  <li>至少3个备用地址在线</li>
  <li>7x24小时技术支持</li>
</ul>

<p>感谢所有用户的支持！我们将不断优化服务，为您提供更好的体验。</p>`,
    date: '2026-06-15',
    readTime: '3分钟',
    views: 25600,
    imageSeq: 'article-launch-announce',
  },
  {
    slug: 'gonggao-weihu-tongzhi',
    title: '系统维护通知：2026年7月例行维护计划',
    category: 'gonggao',
    categoryName: '官方公告',
    excerpt: '为提升服务稳定性，我们将于7月进行例行系统维护。维护期间部分功能可能短暂不可用，请提前做好准备。',
    content: `为持续提升服务质量，我们计划在7月进行例行系统维护。

<h2>维护时间</h2>
<ul>
  <li>预计时间：2026年7月15日 02:00 - 06:00（北京时间）</li>
  <li>影响范围：部分备用节点</li>
  <li>预计影响时长：不超过4小时</li>
</ul>

<h2>维护内容</h2>
<ul>
  <li>服务器硬件升级</li>
  <li>网络带宽扩容</li>
  <li>安全补丁更新</li>
  <li>数据库优化</li>
</ul>

<h2>用户须知</h2>
<p>维护期间，主域名访问不受影响。备用地址可能出现短暂中断，维护完成后将自动恢复。</p>
<p>我们已尽可能将维护安排在凌晨时段，以减少对用户的影响。如有任何问题，请联系技术支持。</p>`,
    date: '2026-06-10',
    readTime: '2分钟',
    views: 19300,
    imageSeq: 'article-maintenance',
  },
  {
    slug: 'gonggao-xinbanben-fabu',
    title: '重要通知：地址发布页2.0版本全新发布',
    category: 'gonggao',
    categoryName: '官方公告',
    excerpt: '地址发布页迎来重大版本更新！全新的界面设计、更智能的地址推荐、更强大的监控系统——2.0版本带来全方位的体验升级。',
    content: `经过团队的持续努力，地址发布页2.0版本正式发布！

<h2>全新界面设计</h2>
<p>我们重新设计了用户界面，采用了全新的视觉风格：</p>
<ul>
  <li>简洁现代的卡片式布局</li>
  <li>更清晰的信息层次结构</li>
  <li>优化的移动端适配体验</li>
  <li>符合无障碍标准的色彩对比</li>
</ul>

<h2>功能升级</h2>
<ul>
  <li><strong>智能推荐</strong>：根据网络环境自动推荐最佳节点</li>
  <li><strong>实时监控</strong>：节点状态实时更新，毫秒级延迟检测</li>
  <li><strong>一键测速</strong>：快速检测所有节点响应速度并排序</li>
  <li><strong>通知中心</strong>：统一管理所有更新通知和公告</li>
</ul>

<h2>性能优化</h2>
<ul>
  <li>页面加载速度提升60%</li>
  <li>首屏渲染时间缩短至1秒以内</li>
  <li>静态资源全球CDN加速</li>
  <li>离线浏览支持</li>
</ul>

<p>立即体验全新的2.0版本，感受不一样的地址导航服务！</p>`,
    date: '2026-06-01',
    readTime: '3分钟',
    views: 32100,
    imageSeq: 'article-v2-release',
  },
  {
    slug: 'anquan-fang-diaoyu',
    title: '安全警示：如何识别和防范钓鱼网站',
    category: 'anquan',
    categoryName: '安全指南',
    excerpt: '钓鱼网站是网络安全的主要威胁之一。本文教您如何快速识别钓鱼网站，以及采取哪些措施保护自己不受钓鱼攻击。',
    content: `钓鱼网站会伪装成官方网站来窃取用户信息。学会识别和防范钓鱼攻击，是保护自身安全的重要技能。

<h2>如何识别钓鱼网站</h2>
<ul>
  <li><strong>检查网址</strong>：钓鱼网站通常使用与官方相似的域名，但会有细微差别，如字母替换（o换成0）</li>
  <li><strong>查看SSL证书</strong>：点击地址栏锁形图标查看证书信息是否与官方一致</li>
  <li><strong>注意页面细节</strong>：钓鱼网站通常存在排版混乱、错别字、图片模糊等问题</li>
  <li><strong>警惕异常要求</strong>：官方不会通过弹窗要求输入密码或验证码</li>
</ul>

<h2>防范措施</h2>
<ul>
  <li>始终通过本地址发布页访问官方网站</li>
  <li>不要在搜索引擎广告链接中点击进入</li>
  <li>安装可靠的安全防护软件</li>
  <li>开启浏览器的安全浏览功能</li>
</ul>

<h2>发现钓鱼网站怎么办？</h2>
<ol>
  <li>不要输入任何信息</li>
  <li>立即关闭页面</li>
  <li>通过"关于我们"页面举报可疑网站</li>
  <li>如已输入信息，立即修改密码</li>
</ol>`,
    date: '2026-05-25',
    readTime: '5分钟',
    views: 22100,
    imageSeq: 'article-anti-phishing',
  },
  {
    slug: 'anquan-mima-baohu',
    title: '密码安全最佳实践：创建和管理强密码的完整指南',
    category: 'anquan',
    categoryName: '安全指南',
    excerpt: '密码是保护账户安全的第一道防线。本文介绍创建强密码的科学方法、密码管理工具推荐以及密码泄露后的应急处理流程。',
    content: `一个好的密码可以极大降低账户被盗的风险。以下是创建和管理密码的最佳实践。

<h2>强密码的标准</h2>
<ul>
  <li>长度至少12个字符（越长越安全）</li>
  <li>包含大写字母（A-Z）</li>
  <li>包含小写字母（a-z）</li>
  <li>包含数字（0-9）</li>
  <li>包含特殊字符（!@#$%^&*）</li>
  <li>不包含个人信息</li>
  <li>不使用常见词汇</li>
</ul>

<h2>密码管理建议</h2>
<ul>
  <li>不同平台使用不同密码</li>
  <li>推荐使用密码管理器</li>
  <li>定期更换密码（建议每90天）</li>
  <li>不在公共设备保存密码</li>
</ul>

<h2>密码泄露应急处理</h2>
<ol>
  <li>立即修改泄露账户的密码</li>
  <li>检查其他使用相同密码的账户</li>
  <li>开启二次验证</li>
  <li>关注账户近期活动记录</li>
</ol>`,
    date: '2026-05-20',
    readTime: '4分钟',
    views: 18700,
    imageSeq: 'article-password-safety',
  },
  {
    slug: 'anquan-erci-yanzheng',
    title: '二次验证完全指南：为您的账户加一道安全锁',
    category: 'anquan',
    categoryName: '安全指南',
    excerpt: '二次验证（2FA）是目前最有效的账户保护手段之一。本文详细介绍各种二次验证方式的优缺点及设置方法。',
    content: `二次验证可以防止即使密码被泄露，攻击者也无法登录您的账户。

<h2>什么是二次验证？</h2>
<p>二次验证（Two-Factor Authentication，简称2FA）是在密码之外增加的第二层身份验证。登录时除了输入密码，还需要提供第二种验证方式。</p>

<h2>常见的二次验证方式</h2>
<ul>
  <li><strong>短信验证码</strong>：通过手机短信接收验证码，方便但安全性一般</li>
  <li><strong>验证器应用</strong>：使用Google Authenticator等应用生成动态验证码，安全性高</li>
  <li><strong>硬件密钥</strong>：使用USB安全密钥（如YubiKey），安全性最高</li>
  <li><strong>生物识别</strong>：指纹、面部识别等，便捷且安全</li>
</ul>

<h2>推荐设置</h2>
<ol>
  <li>首选验证器应用</li>
  <li>备用手机短信验证码</li>
  <li>保存恢复码到安全位置</li>
  <li>定期检查二次验证设置</li>
</ol>

<h2>注意事项</h2>
<ul>
  <li>不要将验证码告诉任何人</li>
  <li>定期备份验证器应用的数据</li>
  <li>更换手机前先迁移二次验证设置</li>
  <li>保存好恢复码</li>
</ul>`,
    date: '2026-05-15',
    readTime: '5分钟',
    views: 15400,
    imageSeq: 'article-2fa-guide',
  },
  {
    slug: 'gengxin-v2-1-0',
    title: '版本更新日志 v2.1.0 - 智能路由与性能优化',
    category: 'gengxin',
    categoryName: '版本更新',
    excerpt: 'v2.1.0版本聚焦于智能路由算法升级和整体性能优化，新增节点健康度评分和自动故障转移功能，让地址导航更加智能可靠。',
    content: `v2.1.0版本已正式发布，本次更新重点优化了智能路由算法和系统性能。

<h2>新功能</h2>
<ul>
  <li><strong>智能路由2.0</strong>：全新的节点选择算法，综合考虑延迟、负载和稳定性</li>
  <li><strong>节点健康度评分</strong>：每个备用节点都有实时健康度评分</li>
  <li><strong>自动故障转移</strong>：当前节点异常时自动切换到最优备用节点</li>
  <li><strong>访问历史面板</strong>：可查看和管理最近的访问记录</li>
</ul>

<h2>性能优化</h2>
<ul>
  <li>首屏加载时间减少35%</li>
  <li>API响应速度提升50%</li>
  <li>资源压缩率提高20%</li>
  <li>内存占用降低15%</li>
</ul>

<h2>问题修复</h2>
<ul>
  <li>修复了部分移动设备上的显示异常</li>
  <li>修复了通知推送重复的问题</li>
  <li>修复了某些DNS环境下的解析错误</li>
  <li>修复了暗色模式下的若干样式问题</li>
</ul>`,
    date: '2026-05-10',
    readTime: '2分钟',
    views: 9800,
    imageSeq: 'article-v2-1-0',
  },
  {
    slug: 'gengxin-v2-0-0',
    title: '版本更新日志 v2.0.0 - 全新架构与界面升级',
    category: 'gengxin',
    categoryName: '版本更新',
    excerpt: '地址发布页2.0是一个里程碑式的版本，从前端到后端进行了全面重构。全新界面、更强性能、更多功能，带来质的飞跃。',
    content: `地址发布页2.0版本是一次全面的架构升级。

<h2>架构升级</h2>
<ul>
  <li>前端框架升级至React 19</li>
  <li>采用微服务架构</li>
  <li>引入Kubernetes容器编排</li>
  <li>数据库迁移至分布式集群</li>
</ul>

<h2>界面升级</h2>
<ul>
  <li>全新的视觉设计语言</li>
  <li>响应式布局全面优化</li>
  <li>暗色模式支持</li>
  <li>无障碍功能完善</li>
</ul>

<h2>功能新增</h2>
<ul>
  <li>智能地址推荐系统</li>
  <li>实时节点监控面板</li>
  <li>多维度搜索功能</li>
  <li>个性化设置中心</li>
</ul>

<h2>重大变更</h2>
<ul>
  <li>旧版API将于3个月后停止支持</li>
  <li>部分旧版功能已整合或移除</li>
  <li>建议所有用户更新书签到新版地址</li>
</ul>`,
    date: '2026-04-20',
    readTime: '3分钟',
    views: 13500,
    imageSeq: 'article-v2-0-0',
  },
  {
    slug: 'gengxin-v1-5-0',
    title: '版本更新日志 v1.5.0 - 移动端优化与通知系统',
    category: 'gengxin',
    categoryName: '版本更新',
    excerpt: 'v1.5.0版本专注于移动端体验优化和通知系统完善，新增PWA支持和多渠道通知推送功能。',
    content: `v1.5.0版本已正式发布，移动端体验迎来重大提升。

<h2>移动端优化</h2>
<ul>
  <li><strong>PWA支持</strong>：可将本站添加到手机主屏幕，像原生应用一样使用</li>
  <li><strong>触摸优化</strong>：按钮和链接间距针对手指操作优化</li>
  <li><strong>离线浏览</strong>：无网络时也可查看缓存的地址信息</li>
  <li><strong>手势支持</strong>：支持滑动返回等手势操作</li>
</ul>

<h2>通知系统</h2>
<ul>
  <li>浏览器推送通知</li>
  <li>邮件通知优化（支持HTML格式）</li>
  <li>通知偏好设置</li>
  <li>重要通知置顶功能</li>
</ul>

<h2>其他改进</h2>
<ul>
  <li>页面加载动画优化</li>
  <li>搜索功能增强</li>
  <li>错误页面美化</li>
  <li>多语言支持增强</li>
</ul>`,
    date: '2026-04-10',
    readTime: '2分钟',
    views: 8200,
    imageSeq: 'article-v1-5-0',
  },
];